export function updateImagePaths(imagePath: string) {
  return imagePath;
}

export function updateImagePathsRegExp(response: string) {
  return response;
}

export function updateImagePathsRegExpFromBlocks(response: string) {
  return response;
}

// Converts an image source to a dynamic next image if it's an internal cdn url
export function convertToNextImage(src: string, _useBaseUrl = true) {
  return src;
}
